import { useState } from "react";
import { Globe, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePro } from "@/contexts/ProContext";
import { LANGUAGES } from "@/lib/i18n";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";

export const LanguagePicker = () => {
  const { language, setLanguage } = usePro();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const filtered = LANGUAGES.filter((l) => {
    const s = q.toLowerCase();
    return !s || l.label.toLowerCase().includes(s) || l.native.toLowerCase().includes(s);
  });
  const indian = filtered.filter((l) => l.group === "indian");
  const global = filtered.filter((l) => l.group === "global");
  const suggested = filtered.filter((l) => l.group === "suggested");

  const pick = async (code) => {
    await setLanguage(code);
    setOpen(false);
  };

  const renderGroup = (label, items) => items.length > 0 && (
    <div className="mb-2">
      <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-muted-foreground px-2 py-1.5">── {label} ──</div>
      {items.map((l) => (
        <button
          key={l.code}
          onClick={() => pick(l.code)}
          className="w-full flex items-center justify-between px-3 py-2 rounded-md text-sm hover:bg-foreground/5 transition text-start"
          data-testid={`lang-opt-${l.code}`}
        >
          <span>{l.native} <span className="text-muted-foreground text-xs">· {l.label}</span>{l.rtl ? <span className="ml-2 text-[10px] text-muted-foreground">(RTL)</span> : null}</span>
          {language === l.code && <Check className="h-4 w-4 brand-text" strokeWidth={2} />}
        </button>
      ))}
    </div>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className="h-9 w-9 rounded-md hover:bg-foreground/5 flex items-center justify-center transition"
          aria-label={t("nav.language")}
          data-testid="language-picker-btn"
        >
          <Globe className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-2 bg-card border-border max-h-[70vh] overflow-y-auto scrollbar-thin" data-testid="language-picker-panel">
        <div className="p-1 mb-2">
          <Input
            value={q} onChange={(e) => setQ(e.target.value)}
            placeholder={t("common.search")}
            className="h-9 bg-muted border-border"
            data-testid="lang-search"
          />
        </div>
        {renderGroup("Suggested", suggested)}
        {renderGroup("🇮🇳 Indian", indian)}
        {renderGroup("🌍 Global", global)}
      </PopoverContent>
    </Popover>
  );
};
